import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {PermissionsService} from "../../../../services/permissions/permissions.service";

@Component({
  selector: 'app-blank-questionnaire',
  templateUrl: './blank-questionnaire.component.pug',
  styleUrls: ['./blank-questionnaire.component.scss'],
  standalone: false
})
export class BlankQuestionnaireComponent implements OnInit {
  constructor(public permissions: PermissionsService) {
  }

  @Output() addQuestion = new EventEmitter();

  ngOnInit(): void {
  }

  addClick(){
    this.addQuestion.emit({});
  }

}
